var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"demon-trend-chart"},[_c('div',{style:({
      width: `${_vm.screenSize.width * 0.946}px`,
      height: `${_vm.screenSize.width}px`,
    }),attrs:{"id":"container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }